import EdButton from '@Components/UI/Buttons/EdButton/EdButton';
import EdIcon from '@Components/UI/Utilities/EdIcon/EdIcon';
import { FlexLayout, Typography } from '@eduact/ed-system';
import { LoginAsRequester } from '@Pages/Students/Services/LoginAs.Requester';
import { StudentsRequester } from '@Pages/Students/Services/Students.Requester';
import { SingleStudentData } from '@Services/students/students.res.types';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';

type LoginAsStudentProps = {};
const LoginAsStudent: React.VoidFunctionComponent<LoginAsStudentProps> = () => {
	const [student, setStudent] = useState<SingleStudentData | undefined>();
	const [embedUrl, setEmbedUrl] = useState<string | undefined>();
	const { id } = useParams<{ id: string }>();

	useEffect(() => {
		const start = async () => {
			try {
				// Two separate calls now. The name is display-only and comes from
				// the ordinary student endpoint; the impersonation code is minted
				// on its own and is the only thing that grants access.
				const [studentRes, codeRes] = await Promise.all([
					StudentsRequester.getInstance().get(id),
					LoginAsRequester.getInstance().loginAs(id),
				]);
				setStudent(studentRes.data.data);

				// The code goes in the URL, but unlike the token it replaced it is
				// single-use and expires in two minutes, so a copy in history or an
				// access log is worth nothing. The portal spends it immediately for
				// an httpOnly cookie and strips it from its own URL.
				const studentUrl = new URL(process.env.REACT_APP_STUDENT_URL);
				studentUrl.searchParams.set('embed', 'true');
				studentUrl.searchParams.set(
					'impersonationCode',
					codeRes.data.data.code
				);
				setEmbedUrl(studentUrl.toString());
			} catch (error) {}
		};
		start();
	}, [id]);

	const history = useHistory();
	const backToDashboard = () => {
		history.push('/dashboard/students');
	};
	return (
		<>
			<FlexLayout
				alignItems={'center'}
				gridGap="0.5rem"
				p={'1rem'}
				onClick={backToDashboard}
			>
				<EdButton
					variant="contained"
					startIcon={<EdIcon mIconType="Outlined">undo</EdIcon>}
				>
					Back to dashboard
				</EdButton>
				<Typography>Logged in as</Typography>
				<Typography fontWeight={'bold'}>
					{student?.first_name} {student?.last_name}
				</Typography>
			</FlexLayout>
			{embedUrl && <StyledIframe src={embedUrl} />}
		</>
	);
};

export default LoginAsStudent;

const StyledIframe = styled.iframe`
	width: 100vw;
	height: 100%;
`;
